"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Close = _interopRequireDefault(require("./../Icons/Close"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Box = _styledComponents.default.div.withConfig({
  displayName: "Box"
})(["display:flex;align-items:center;padding:19px 20px 15px 22px;border:1px solid ", ";box-sizing:border-box;justify-content:space-between;box-shadow:0px 2px 5px rgba(0,0,0,0.05);border-radius:5px;&:last-child{margin-right:0;}img{max-width:50px;}svg{cursor:pointer;}span{font-size:15px;}.fileName{font-weight:500;margin-right:1vw;max-width:10vw;}.fileSize{color:#76726e;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.ui.outline;
});

Box.displayName = 'Box';

var Left = _styledComponents.default.div.withConfig({
  displayName: "Left"
})(["display:flex;flex-direction:column;"]);

var Right = _styledComponents.default.div.withConfig({
  displayName: "Right"
})(["display:flex;align-items:center;@media (max-width:900px){flex-direction:row;}"]);

var LoadingBar = _styledComponents.default.div.withConfig({
  displayName: "LoadingBar"
})(["width:", ";height:5px;background-color:", ";margin-top:11px;&:before{content:'';width:", ";transition:", ";height:5px;position:absolute;background-color:", ";}"], function (_ref2) {
  var loaded = _ref2.loaded;
  return loaded !== null ? '22vw' : 0;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.ui.backgroundLight;
}, function (_ref4) {
  var loaded = _ref4.loaded;
  return "calc(".concat(loaded, " / 100 * 22vw);");
}, function (_ref5) {
  var loaded = _ref5.loaded;
  return loaded === 0 ? null : 'width 1s';
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.brand.primary;
});

var FileBox = function FileBox(_ref7) {
  var className = _ref7.className,
      name = _ref7.name,
      size = _ref7.size,
      source = _ref7.source,
      loaded = _ref7.loaded,
      onClose = _ref7.onClose,
      children = _ref7.children;
  return size ? /*#__PURE__*/_react.default.createElement(Box, {
    className: className
  }, /*#__PURE__*/_react.default.createElement(Left, null, /*#__PURE__*/_react.default.createElement("img", {
    src: source,
    alt: name
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "fileName"
  }, name), size ? /*#__PURE__*/_react.default.createElement("span", {
    className: "fileSize"
  }, size) : /*#__PURE__*/_react.default.createElement(LoadingBar, {
    loaded: loaded
  })), /*#__PURE__*/_react.default.createElement(Right, null, children, /*#__PURE__*/_react.default.createElement(_Close.default, {
    onClick: function onClick() {
      return onClose({
        name: name,
        size: size,
        img: source
      });
    }
  }))) : null;
};

FileBox.defaultProps = {
  onClose: Function.prototype
};
FileBox.propTypes = {
  children: _propTypes.node,
  className: _propTypes.string,
  name: _propTypes.string,
  size: _propTypes.number,
  source: _propTypes.string,
  loaded: _propTypes.number,
  onClose: _propTypes.func
};
var _default = FileBox;
exports.default = _default;